import { BASE_URL } from '../constants/api';

import { createGetAPI } from '@cuemath/rest-api';

const { useGet } = createGetAPI({
  getURL: userId => `${BASE_URL}/maintenance/${userId}`,
});

export { useGet as useGetMaintenance };
